import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { C2Button } from '../components/c2';
import AuthShell from '../components/auth/AuthShell';
import { api } from '../lib/api';

export default function MagicSentPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email ?? 'you@company.com';
  const [seconds, setSeconds] = useState(30);

  useEffect(() => {
    if (seconds <= 0) return;
    const t = setTimeout(() => setSeconds(s => s - 1), 1000);
    return () => clearTimeout(t);
  }, [seconds]);

  const resend = async () => {
    if (seconds > 0 || email === 'you@company.com') return;
    try {
      await api.magicLink(email);
      setSeconds(30);
    } catch {
      // Soft-fail; the page still indicates resend is unavailable for the cooldown.
    }
  };

  return (
    <AuthShell>
      <div className="text-center">
        <div
          className="w-[72px] h-[72px] rounded-full mx-auto mb-5 flex items-center justify-center"
          style={{ background: 'var(--accent-soft)', color: 'var(--accent-deep)', fontSize: 32 }}
        >
          ✉
        </div>
        <h2
          className="font-display font-extrabold text-ink m-0 mb-2.5"
          style={{ fontSize: 28, letterSpacing: '-0.02em' }}
        >
          Check your email
        </h2>
        <p className="text-[15px] text-ink-soft m-0 mb-7 leading-[1.55]">
          We sent a sign-in link to <strong className="text-ink">{email}</strong>. Click the link in the email to sign in.
        </p>
        <div className="text-[13px] text-ink-muted mb-5">
          Didn't get it?{' '}
          {seconds > 0 ? (
            <span>Resend in {seconds}s</span>
          ) : (
            <button
              onClick={resend}
              className="bg-transparent border-0 cursor-pointer p-0 font-semibold text-[13px]"
              style={{ color: 'var(--accent-solid)' }}
            >
              Resend link
            </button>
          )}
        </div>
        <C2Button variant="outline" onClick={() => navigate('/login')}>
          Sign in with password instead
        </C2Button>
      </div>
    </AuthShell>
  );
}
